import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import LargeText from '@/large-text'

import './styles.css'

const SectionApp = ({ gray, data }) => {
  return (
    <BusinessSection
      title="Next Miss app"
      subtitle="One platform for all beauty pageants"
      gray={gray}
    >
      <div className="mw792 center">
        <div className="flex mb4">
          <Item imgSrc={data.nextMissApp1.sizes} />
          <Item imgSrc={data.nextMissApp2.sizes} />
          <Item imgSrc={data.nextMissApp3.sizes} />
          <Item imgSrc={data.nextMissApp4.sizes} />
        </div>
        <LargeText>
          Get your beauty pageant listed on Next Miss Media and get new visibility and revenue. Our team will help you to get started.
        </LargeText>
      </div>
    </BusinessSection>
  )
}

function Item({ imgSrc }) {
  return (
    <div className="w-25">
      <Img sizes={imgSrc} alt="" />
    </div>
  )
}

export default SectionApp



// WEBPACK FOOTER //
// ./src/components/section-app/section-app.js